import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {SUBJECT, SUBJECT_API_URL, GET_ALL_SUBJECT_API_URL} from 'constants/AppConstants';
import { USER_All_INFORMATION } from "constants/AuthConstant";
import CommonService from 'services/CommonService/CommonService';
import IntlMessage from "components/util-components/IntlMessage";
const setLocale = (localeKey, isLocaleOn = true) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();
const permission = JSON.parse(localStorage.getItem(USER_All_INFORMATION));

export const initialState = {
  SubjectErrors       : {},
  permission: permission?.subject ?? [],
  SubjectShowMessage  : null,
  SubjectResult       : [],
  SubjectButtonSpinner : false,
  SubjectTableLoading : true,
  SubjectAddDrawer    : false,
  SubjectEditData     : [],
  SubjectButtonAndModelLabel  : setLocale('subject.add'),
  tablePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
    },
    sorting: {},
    filter: {},
    ViewSubjectData: [],
    ViewSubjectLoader: true,
    DrawerStatus: 0,
};

export const createSubject = createAsyncThunk(
    "createSubject",
  async (data) => {
    try {
      const response = await CommonService.createAndUpdate(data, SUBJECT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const getSubject = createAsyncThunk(
    "getSubject",
  async (data) => {
    try {
      const response = await CommonService.getAllPost(data, GET_ALL_SUBJECT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const viewSubject = createAsyncThunk(
  "viewSubject",
  async (id) => {
    try {
      const response = await CommonService.showOne(id, SUBJECT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const deleteSubject = createAsyncThunk(
  "deleteSubject",
  async (data) => {
    try {
      const response = await CommonService.deleteOne(data, SUBJECT_API_URL);
      return response;
    } catch (err) {
      throw new Error(JSON.stringify(err.response.data.errors)); // Throw an error with the server response errors
    }
  }
);

export const manageSubjectSlice = createSlice({
  name: SUBJECT,
  initialState,
  reducers: {
    onCloseError: (state, action) => {
      state.SubjectErrors = {};
    },
    SubjectAddDrawerStatus: (state, action) => {
        if (action.payload.status === false) {
            state.SubjectButtonSpinner = false;
      }
      state.SubjectAddDrawer   = action.payload.status;
      state.DrawerStatus = action.payload.errorStatus;
      state.SubjectEditData    = [];
      state.SubjectButtonAndModelLabel = setLocale('subject.add');
    },
    SubjectEditWithDrawerStatus: (state, action) => {
      state.SubjectAddDrawer = true;
      state.DrawerStatus = action.payload.errorStatus;
      state.SubjectEditData = action.payload.data;
      state.SubjectButtonAndModelLabel = setLocale('subject.edit');
    },
    updateSortFilters: (state, action) => {
        state.filter = action.payload.filter;
        state.sorting = action.payload.sorting;
    },
    setColumnSearch: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSubject.pending, (state, action) => {
        state.DrawerStatus = 0
        state.SubjectButtonSpinner = true;
      }).addCase(createSubject.fulfilled, (state, action) => {
        state.DrawerStatus = 0
        state.SubjectButtonSpinner = false;
        state.SubjectErrors = {}
      }).addCase(createSubject.rejected, (state, action) => {
        state.DrawerStatus = 1
        state.SubjectShowMessage = true;
        state.SubjectButtonSpinner = false;
        state.SubjectErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      }).addCase(getSubject.pending, (state, action) => {
        state.SubjectButtonSpinner = true;
        state.SubjectTableLoading = true;
      }).addCase(getSubject.fulfilled, (state, action) => {
        state.SubjectButtonSpinner = false;
        state.SubjectTableLoading = false;
        state.SubjectResult = action.payload;
        state.tablePagination = {
            ...state.tablePagination,
            total: action.payload.pagination.total,
            current: action.payload.pagination.current_page,
            pageSize: action.payload.pagination.per_page
        };
      }).addCase(getSubject.rejected, (state, action) => {
        state.SubjectShowMessage = true; // Set the showMessage flag to display the errors
        state.SubjectButtonSpinner = false;
        state.SubjectTableLoading = false;
        state.SubjectErrors = JSON.parse(action.error.message); // Parse the error messages and store them in the state
      })
      .addCase(viewSubject.pending, (state, action) => {
        state.ViewSubjectLoader = true;
        state.ViewSubjectData = [];
      }).addCase(viewSubject.fulfilled, (state, action) => {
        state.ViewSubjectLoader = false;
        state.ViewSubjectData = action.payload;
      }).addCase(viewSubject.rejected, (state, action) => {
        state.ViewSubjectLoader = false;
        state.ViewSubjectData = [];
      })
      .addCase(deleteSubject.pending, (state, action) => {
        state.SubjectTableLoading = true;
      }).addCase(deleteSubject.fulfilled, (state, action) => {
        state.SubjectTableLoading = false;
      }).addCase(deleteSubject.rejected, (state, action) => {
        state.SubjectTableLoading = false;
      });
  },
});

export const { onCloseError, setColumnSearch, SubjectAddDrawerStatus, SubjectEditWithDrawerStatus, updateSortFilters } = manageSubjectSlice.actions;

export default manageSubjectSlice.reducer;